function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".playClass{fill:#FFF0D7;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "platButton");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "playClass",
  d: "M65.8,47.5,42.7,32.1a3,3,0,0,0-4.6,2.5V65.4a3,3,0,0,0,4.6,2.5L65.8,52.5A3,3,0,0,0,65.8,47.5Z",
  transform: "translate(-2.5 -2.5)"
}), /*#__PURE__*/React.createElement("path", {
  className: "playClass",
  d: "M50,2.5A47.5,47.5,0,1,0,97.5,50,47.54,47.54,0,0,0,50,2.5Zm0,87.6A40.1,40.1,0,1,1,90.1,50,40.16,40.16,0,0,1,50,90.1Z",
  transform: "translate(-2.5 -2.5)"
}));

var SvgPlayIcon = function SvgPlayIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 95 95",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlayIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/playIcon.e6336357.svg";
export { ForwardRef as ReactComponent };